import Img from 'gatsby-image'
import styled from 'styled-components'

export const TestimoniesWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
`

export const TestimoniesImage = styled(Img)`
  min-width: 100%;
  height: auto;
`
